<div id="loading-overlay" @fadeInOut *ngIf="isLoading" [class.full]="isFullScreen">
    <div class="loading-animation">
        <div class="horizontal-line"></div>
        <div class="vertical-line"></div>
        <div class="division-blocks top-block"></div>
        <div class="division-blocks bottom-block"></div>
    </div>
</div>
